import axios from 'axios';
import LogService from './log-service';

const isNode = typeof __webpack_require__ === 'undefined'; //eslint-disable-line

export default class IPAddressService {
  static ipAddress = '';

  static initialized = false;

  static initialize() {
    if (isNode || IPAddressService.initialized) {
      return;
    }

    IPAddressService.initialized = true;
    const interval = 30 * 60000;
    setInterval(IPAddressService.getIPAddress, interval);
    IPAddressService.getIPAddress();
  }

  static getIPAddress() {
    axios
      .get('/getIPAddress', {
        baseURL: '',
      })
      .then((response) => {
        IPAddressService.ipAddress = response.data;
      })
      .catch(LogService.logError);
  }
}

IPAddressService.initialize();
